@import '../../stylesheets/mixins/common.styl'
@import '../../stylesheets/defaults'

warning-image-styles(image-path)
  background url(image-path) var(--background-color) no-repeat 90px
  background-position center
  // width and height from the svg
  height 124px
  margin auto
  width 171px

.mp-warning-container
  background var(--background-color)  // use svg-icon alert.svg in template
  font-size $font-size-medium
  font-weight $weight-medium
  margin 32px 24px
  text-align center

  &.small
    margin 12px

  .mp-warning-cta
    color var(--blue1)
    cursor pointer
    svg-icon-style('%s' % var(--blue1), size: 20px, pos-top: 5px, speed: 0)

    &:hover
      text-decoration underline

.mp-warning-laptop-svg
  warning-image-styles('./images/laptop.svg')

.mp-warning-no-data-svg
  warning-image-styles('./images/no-data-laptop.svg')

.mp-warning-content
  margin auto
  margin-bottom 20px

  > svg-icon
    svg-icon-style-props(size: 60px)

  h1
    color var(--primary-text-color)
    font-size $font-size-large

  h1.theme-tip
    font-size $font-size-large
    font-weight $weight-medium
    height 22px
    line-height 22px
    margin-bottom 0
    margin-top 4px

  .body-text
    color var(--tertiary-text-color)
    line-height $font-size-medium

  mp-markdown.theme-tip
    color var(--primary-text-color)
    display block
    font-size $font-size-large
    font-weight $weight-regular
    height 44px
    line-height 22px
    max-width 400px

  svg-icon[icon='warning']
    color var(--red1)

  svg-icon[icon='lock']
    color var(--tertiary-text-color)

  &.small
    > svg-icon
      svg-icon-style-props(size: 20px)
